<ng-container *transloco="let _t">

<h5><mat-icon>check_circle_outline</mat-icon> {{ _t('mdr-checklist-h5-0') }}</h5>
<mat-progress-bar mode="determinate" [value]="action.todoRatio" color="primary"></mat-progress-bar>

<ul class="tasklist" *ngIf="showTODO">
	<li *ngFor="let todo of action.jsonDetails.todo; let i=index" [id]="'task'+i">

		<button mat-icon-button *ngIf="!todo.edit" (click)="todo.confirming=true" class="delBtn">
			<mat-icon>remove_circle_outline</mat-icon>
		</button>

		<div class="confirming" *ngIf="todo.confirming" >
			Supprimer cette tâche ?<br>
			<button mat-raised-button  color="disabled"
			(click)="action.jsonDetails.todo.splice(i,1); todo.confirming=false">
				{{ _t('Confirmer') }}
			</button> &nbsp;
			<button mat-raised-button color="warn" (click)="todo.confirming=false">
				{{ _t('Annuler') }}
			</button>
		</div>

		<mat-checkbox [(ngModel)]="todo.done" *ngIf="!todo.edit"
					  (change)="setTodoDate(todo, $event.checked)">
			<p>
				<span class="task" [ngClass]="{'done':todo.done}"
					  [title]="_t('mdr-checklist-title-0')" 
					  (dblclick)="focusTODO(todo, i)">
				  {{todo.task}}
				</span>
				<small class="info" *ngIf="todo.done">
					<br>
					&nbsp; fait le {{todo.doneDate | date:'short':undefined:'fr-FR'}}
				</small>
			</p>
		</mat-checkbox>
		<input *ngIf="todo.edit" 
				class="input" 
				[placeholder]="_t('mdr-checklist-placeholder-0')"
				[(ngModel)]="todo.task" 
				[focusMe]="true" [selectMe]="true"
				(blur)="blurTODO(todo, i)"
				(keydown)="blurTODO(todo, i, $event)" />
	</li>
	<li>
		<button mat-flat-button color="basic"
				(click)="addTODO()">
			<mat-icon>add_task</mat-icon> Ajouter une tâche
		</button>
	</li>
</ul>

</ng-container>